import { html } from 'lit';
import { Calculator } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-calculator')
export class PdsIconCalculator extends PdsIcon {
  @state()
  icon = Calculator;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
